import { Icon, PrimaryButton } from "@fluentui/react";
import { TemplateView } from "@taskpane/components";
import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { useRedirect } from "@taskpane/hooks";
import { useTranslation } from "react-i18next";
import { setColor } from "@taskpane/theme";
import { setApiURL } from "@taskpane/utils";
import { Endpoints } from "../../core/endpoints";

import { ApiKeyRequestDTO, ApiKeyRequestResult, ApiKeyRequestStatusDTO, izireportAppName, izireportIdentifier } from "@taskpane/types";

import { useStore } from "@taskpane/hooks";


export const Login = () => {
  const { t } = useTranslation();
  const loginSucceeded = useStore((state: any) => state.loginSucceeded);
  const { setLoginSucceeded, setToken, setTenantName, setTenant, setTenantUserEmail } = useStore();
  const [myApiKey, setMyApiKey] = useState(null); // todo to zustand
  const [myAuthUrl, setMyAuthUrl] = useState(""); // todo to zustand?  

  const [loginError, setLoginError] = useState(null);

  const { redirectTo } = useRedirect();

  const handleOnSubmit = async () => {
    //dispatch(signIn(true));
  };

  const handleOnSubmitV2 = async () => {
    let url = setApiURL(Endpoints.createApiKeyRequest());

    const headers = {
      'Content-Type': 'application/json',
    };

    const body = JSON.stringify({
      appName: izireportAppName,
      clientIdentifier: izireportIdentifier
    });

    let val: ApiKeyRequestDTO = await fetch(url, { method: 'POST', headers, body }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      };
      return response.json();
    });
    setMyApiKey(val.RequestID);
    setMyAuthUrl(val.AuthUrl);

    if (myApiKey !== null) {
      const dialogClosed = async (_: any): Promise<void> => {
        let urlStatus = setApiURL(Endpoints.getApiKeyRequestStatus(myApiKey));
        let valStatus: ApiKeyRequestStatusDTO = await fetch(urlStatus, { method: 'GET' }).then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          };
          return response.json();
        });

        if (valStatus.RequestResult === ApiKeyRequestResult.OK) {
          setTenant(valStatus.TenantName);
          setTenantName(valStatus.TenantUserName);
          setTenantUserEmail(valStatus.TenantUserEmail);
          setToken(valStatus.ApiKey);
          setLoginSucceeded(true);
          redirectTo("/");
        };
      };

      Office.context.ui.displayDialogAsync(myAuthUrl, null, result => {
        const dialog = result.value;
        dialog.addEventHandler(Office.EventType.DialogEventReceived, dialogClosed);
      });
    }

  };
  return (
    <>
      {!loginSucceeded ? (
        <TemplateView>
          <div className="col col-12 mb-4">
            <div className="ms-fontSize-su text-center">
              <Icon iconName="CubeShape" aria-hidden="true" />
            </div>
            <div className="mb-4 fw-bold text-center fs-4">{t("welcome")}</div>
            <div className="m-3 text-center">
              {t("authCta")}
            </div>
          </div>
          <div className="col col-12 d-flex justify-content-center">
            <PrimaryButton onClick={() => handleOnSubmitV2()}>{t("connect")}</PrimaryButton>
            {loginError ? <span style={{ color: setColor("red") }}>{loginError}</span> : ''}
          </div>
        </TemplateView>
      ) : (
        <Redirect to="/" />
      )}
    </>
  );
};
